<div class="contact-remove">
  <div class="contact-remove__card">
    <div class="contact-remove__container">
      <h1 class="contact-remove__title">{{ hasActiveLicence ? 'Request removal of contact' : 'Remove contact' }}</h1>
      <div class="input-group contact-remove__form-group"><label>Contact Name:</label> {{ email }}</div>
      <div class="input-group contact-remove__form-group">
        <label>Please Note</label>
        <div class="contact-remove__control contact-remove__textarea" title="Notes on removal">
          Before {{ hasActiveLicence ? 'requesting to remove' : 'removing' }} a contact, please check the following:
          <ul>
            @if (!hasActiveLicence) {
              <li>There are no current licences associated with this contact.</li>
            }
            <li>Account permissions will be left in a valid state after removal.</li>
            <li>The account will still have the minimum number of required contact types (Regulatory etc.).</li>
            <li>This user will no longer have access to this account, but may still have access to other accounts.</li>
          </ul>
        </div>
      </div>
      @if (hasActiveLicence) {
        <form [formGroup]="contactSelectionFormGroup">
          <mat-form-field>
            <mat-label>Contact to transfer licence to</mat-label>
            <mat-select formControlName="selectedContact">
              @for (contact of contactList; track $index) {
                <mat-option [value]="contact.id">{{ contact.email }}</mat-option>
              }
            </mat-select>
            <mat-error comFormMessageName="selectedContact">Please select a contact</mat-error>
          </mat-form-field>
        </form>
      }

      @if (isError) {
        <div class="contact-remove__box-error form__error-message" [innerHtml]="errorMessages | arrayToList"></div>
      }
      <div class="contact-remove__buttons-container">
        <button mat-raised-button class="button--secondary button--pad-right" (click)="cancel()">Cancel</button>
        <button mat-raised-button [disabled]="contactSelectionFormGroup.invalid" (click)="removeContact()">
          {{ hasActiveLicence ? 'Request removal' : 'Remove contact' }}
        </button>
      </div>
    </div>
  </div>
</div>
